import { ErpSpan } from './ErpHtml';
import React from 'react';

export interface ErpTooltipProps {
  content?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  children?: React.ReactNode;
  className?: string;
}

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

const _ErpTooltip: React.FC<ErpTooltipProps> = ({
  content,
  placement = 'top',
  children,
  className
}) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <ErpSpan className={className}>{children}</ErpSpan>
        </TooltipTrigger>
        {/* A block-level <p> is invalid inside the inline tooltip content area. */}
        {content && (
          <TooltipContent side={placement}>
            <ErpSpan>{content}</ErpSpan>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
};

export const ErpTooltip = React.memo(_ErpTooltip);
